const resetFields = (fields, helpers) => {
  const newValues = Object.fromEntries(fields.map((field) => [field, void 0]));
  const newTouched = Object.fromEntries(fields.map((field) => [field, false]));
  helpers.setValues((previous) => ({
    ...previous,
    ...newValues
  }));
  helpers.setTouched(newTouched);
};
export {
  resetFields
};
